/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/FormInputs.tsx
 * Created:       Wed Apr 16 2025
 * Modified By:   Greg Olive
 * Last Modified: Wed Apr 16 2025
 */

import React, { useContext } from 'react';
import { FormContext } from "@proxy/_contexts";
import {
  CardDeliveryStep,
  GiftCardStep,
  GiftMessageStep,
  GreetingCardStep,
} from "../_steps";

type FormInputsProps = {
  isEmbedded?: boolean;
  togglePreview: () => void;
};

const FormInputs = ({
  isEmbedded = false,
  togglePreview,
}: FormInputsProps) => {

  const {
    loading,
    formData,
    currency,
    fulfillmentType,
    physicalSurcharge,
  } = useContext(FormContext);

  return ((!loading) ?
    <>
      <CardDeliveryStep togglePreview={togglePreview} />
      <GreetingCardStep togglePreview={togglePreview} />
      <GiftCardStep togglePreview={togglePreview} />
      <GiftMessageStep togglePreview={togglePreview} />

      {(!isEmbedded) ? (
        <input
          type="hidden"
          name="quantity"
          value={1}
          hidden={true}
          readOnly={true}
        />
      ) : null}
      <input
        type="hidden"
        name="properties[_gcp_locale]"
        value={formData.properties._gcp_locale || ""}
        hidden={true}
        readOnly={true}
      />
      <input
        type="hidden"
        name="properties[_gcp_delivery_date]"
        value={formData.properties._gcp_delivery_date || ""}
        hidden={true}
        readOnly={true}
      />
      <input
        type="hidden"
        name="properties[_gcp_conversion_rate]"
        value={formData.properties._gcp_conversion_rate || ""}
        hidden={true}
        readOnly={true}
      />
      <input
        type="hidden"
        name="properties[_gcp_formatted_address]"
        value={formData.properties._gcp_formatted_address || ""}
        disabled={fulfillmentType === 'digital'}
        hidden={true}
        readOnly={true}
      />
      <input
        type="hidden"
        name="properties[_gcp_fulfillment_type]"
        value={fulfillmentType || ""}
        hidden={true}
        readOnly={true}
      />
      {fulfillmentType === "physical" && physicalSurcharge && (
      <input
        type="hidden"
        name="properties[_gcp_physical_surcharge]"
        value={physicalSurcharge.value || ""}
        hidden={true}
        readOnly={true}
      />)}  
      <input
        type="hidden"
        name="properties[_gcp_currency]"
        value={currency?.active || ""}
        hidden={true}
        readOnly={true}
      />
      <input
        type="hidden"
        name="properties[_gcp_country]"
        value={currency?.country || ""}
        hidden={true}
        readOnly={true}
      />
    </>
  : null);
};

export default FormInputs;
